<template>
  <div class="new-dbg-component">
    <section
      v-if="
        submittedSuccessfully &&
        !isError &&
        !isInfoDBC &&
        pageStatus == PAGESTATUS_SUCCESS
      "
      class="alert-success elevation-0"
    >
      <SuccessComponent
        :title="$t('compensation.compensationAccepted')"
      ></SuccessComponent>
      <div class="text-success">
        <p v-if="allCompensationsRejected()">
          {{ $t("compensation.compensationRejected") }}
        </p>
        <p v-else>{{ $t("compensation.formSuccess") }}</p>
      </div>
    </section>
    <!-- FIN Pantalla success  -->
    <v-container
      v-if="
        !submittedSuccessfully &&
        !isError &&
        !isInfoDBC &&
        pageStatus === PAGESTATUS_FORM
      "
    >
      <div class="section-heading mt-3">
        <h1>{{ $t("compensation.selectCompensation") }}</h1>
        <div class="subheading">
          <b
            >{{ $t("compensation.refCompensation") }}:
            {{ tokenStore.caseId }}</b
          >
        </div>
      </div>

      <v-row class="compensation-style">
        <v-col cols="3" class=""></v-col>
        <v-col
          v-if="
            jsonRes?.PassengerCase?.some((passenger) => passenger.AEBondAmount)
          "
          cols="2"
          @click="infoBon"
          >{{ $t("compensationSelection.bono") }}
          <img class="icon-style" src="../../assets/icons-action-alert@2x.png"
        /></v-col>
        <v-col
          cols="2"
          v-if="
            jsonRes?.PassengerCase?.some(
              (passenger) => passenger.MonetaryMaxAmount
            )
          "
          @click="infoMon"
        >
          {{ $t("compensationSelection.monetary") }}
          <img class="icon-style" src="../../assets/icons-action-alert@2x.png"
        /></v-col>
        <v-col
          cols="2"
          v-if="
            jsonRes?.PassengerCase?.some((passenger) => passenger.MilesAmount)
          "
          @click="infoMil"
          >{{ $t("compensationSelection.millas") }}
          <img
            class="icon-style"
            src="../../assets/icons-action-alert@2x.png"
          />
        </v-col>
        <v-col cols="3" @click="infoRefuse"
          >{{ $t("compensationSelection.refuse") }}
          <img
            class="icon-style"
            src="../../assets/icons-action-alert@2x.png"
          />
        </v-col>
      </v-row>
      <v-radio-group
        v-for="(passenger, index) in passengerData"
        :key="index"
        v-model="optionSelected[index]"
      >
        <v-row>
          <v-col cols="3">
            <img class="icon-user2" src="../../assets/usericon.png" />
            <span class="user-name">
              {{ passenger?.BeneficiaryFirstName }}
              {{ passenger?.BeneficiaryLastName }}
            </span>
          </v-col>

          <v-col
            cols="2"
            v-if="jsonRes?.PassengerCase?.some((p) => p.AEBondAmount)"
          >
            <template v-if="passenger?.AEBondAmount">
              <template v-if="$vuetify.breakpoint.smAndDown">
                <v-radio
                  class="custom-radio"
                  :value="1"
                  :disabled="isOptionDisabled(index, 1)"
                ></v-radio>
                <div class="custom-label">
                  {{ formatAmount(passenger.AEBondAmount) + " €" }}
                </div>
              </template>
              <template v-else>
                <v-radio
                  class="custom-radio"
                  :label="formatAmount(passenger.AEBondAmount) + ' €'"
                  :value="1"
                  :disabled="isOptionDisabled(index, 1)"
                ></v-radio>
              </template>
            </template>
            <template v-else>
              <div class="empty-cell"></div>
            </template>
          </v-col>

          <v-col
            cols="2"
            v-if="jsonRes?.PassengerCase?.some((p) => p.MonetaryMaxAmount)"
          >
            <template v-if="passenger?.MonetaryMaxAmount">
              <template v-if="$vuetify.breakpoint.smAndDown">
                <v-radio
                  class="custom-radio"
                  :value="2"
                  :disabled="isOptionDisabled(index, 2)"
                ></v-radio>
                <div class="custom-label">
                  {{ formatAmount(passenger.MonetaryMaxAmount) + " €" }}
                </div>
              </template>
              <template v-else>
                <v-radio
                  class="custom-radio"
                  :label="formatAmount(passenger.MonetaryMaxAmount) + ' €'"
                  :value="2"
                  :disabled="isOptionDisabled(index, 2)"
                ></v-radio>
              </template>
            </template>
            <template v-else>
              <!-- Espacio vacío si no hay monetaria -->
              <div class="empty-cell"></div>
            </template>
          </v-col>

          <v-col
            cols="2"
            v-if="jsonRes?.PassengerCase?.some((p) => p.MilesAmount)"
          >
            <template v-if="passenger?.MilesAmount">
              <template v-if="$vuetify.breakpoint.smAndDown">
                <v-radio
                  class="custom-radio"
                  :value="3"
                  :disabled="isOptionDisabled(index, 3)"
                ></v-radio>
                <div class="custom-label">
                  {{
                    formatMillas(passenger.MilesAmount) +
                    " " +
                    $t("compensation.miles")
                  }}
                </div>
              </template>
              <template v-else>
                <v-radio
                  class="custom-radio"
                  :label="
                    formatMillas(passenger.MilesAmount) +
                    ' ' +
                    $t('compensation.miles')
                  "
                  :value="3"
                  :disabled="isOptionDisabled(index, 3)"
                ></v-radio>
              </template>
            </template>
            <template v-else>
              <!-- Espacio vacío si no hay monetaria -->
              <div class="empty-cell"></div>
            </template>
          </v-col>

          <v-col cols="3" v-if="index === 0">
            <template v-if="$vuetify.breakpoint.smAndDown">
              <v-radio class="custom-radio" :value="4"></v-radio>
              <div class="custom-label">
                {{ $t("compensationSelection.milDes") }}
              </div>
            </template>
            <template v-else>
              <v-radio
                class="custom-radio"
                :label="$t('compensationSelection.milDes')"
                :value="4"
              ></v-radio>
            </template>
          </v-col>
        </v-row>
      </v-radio-group>
      <ValidationObserver
        v-for="(passenger, index) in passengerData"
        :key="'clientFormObs' + index"
        :ref="'clientFormObs' + index"
        tag="form"
      >
        <div v-if="optionSelected[index] === 1" class="data-form">
          <h4>{{ $t("compensationSelection.dbcCbon") }}</h4>
          <h4 class="bono-title">
            {{ $t("compensationSelection.cbonTitle") }}
          </h4>

          <!-- PASAMOS EL PASAJERO SELECCIONADO -->
          <newDataClientDBG
            :ref="'dataClient' + index"
            :passenger="passengerData[index]"
            @validate-form="handleValidation(index, $event)"
            @doc-change="handleDocChange(index, $event)"
          />
        </div>
      </ValidationObserver>
      <br />
      <!-- Formularios monetaria -->
      <ValidationObserver
        v-for="(passenger, index) in passengerData"
        :key="'bankFormObs' + index"
        :ref="'bankFormObs' + index"
        tag="form"
      >
        <div v-if="shouldDisplayDynamicForm(index)" class="data-form">
          <h4>{{ $t("compensation.bankDetailsHeader") }}</h4>
          <DynamicForm
            :ref="'formMonetary' + index"
            :country="passenger.CountryCode"
            @form-ready="(form) => onBankFormReady(index, form)"
            @form-validity="(isValid) => onFormValidity(isValid, index)"
          />
        </div>
      </ValidationObserver>
      <div
        class="d-flex flex-column align-items-end"
        style="position: relative; margin-bottom: 8px; margin-top: 19px"
      >
        <div v-if="duplicateError" class="text-error">
          <img
            class="alert-error"
            src="@/assets/alert.svg"
            alt="Custom card Img"
          />
          {{ $t("compensation.duplicateDocument") }}
        </div>
      </div>
      <div
        class="d-flex flex-column align-items-end"
        style="position: relative; right: 16px; margin-bottom: 8px"
      >
        <v-btn
          class="btn-bank"
          style="margin-right: unset"
          @click="openDialog"
          :disabled="!isFormValid && !Object.values(optionSelected).includes(4)"
        >
          {{ $t("compensation.confirmButtonText") }}
        </v-btn>
      </div>
      <div class="info-style" v-if="Object.keys(optionSelected).length === 0">
        <h4 class="info-title">{{ $t("compensationSelection.info") }}</h4>
        <p class="info-Des">
          {{ $t("compensationSelection.infoDes") }}
          <strong>{{ $t("compensationSelection.infoDes2") }}</strong>
          <span v-if="isEnglish">{{
            $t("compensationSelection.infoDes2en")
          }}</span>
          <br />
          {{ $t("compensationSelection.infoDes3") }}
          <strong>{{ $t("compensationSelection.infoDes4") }}</strong>
          {{ $t("compensationSelection.infoDes5") }}
        </p>
      </div>
    </v-container>
    <!-- Popup errores SAP para monetary  -->
    <BankDetailsSapErrors
      :open="bankDetailsSapErrorsDialog.open"
      @close="bankDetailsSapErrorsDialogToggle"
      :errors="bankDetailsSapErrorsDialog.errors"
    />
    <!-- Popup del icono de "i" información de cada compensación  -->
    <v-dialog v-model="infoDialogBon" width="720" max-width="720">
      <v-card>
        <v-card-text class="pt-3">
          <div style="display: flex; flex-direction: column">
            <v-icon style="align-self: flex-end" @click="infoDialogBon = false"
              >close</v-icon
            >
          </div>
          <TcAebond :dialog="disableDialog"></TcAebond>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="infoDialogMon" width="500">
      <v-card>
        <v-card-text class="pt-3">
          <div class="dialog-style">
            <v-icon style="align-self: flex-end" @click="infoDialogMon = false"
              >close</v-icon
            >
          </div>
          <TcMonetary :dialog="disableDialog"></TcMonetary>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="infoDialogMil" width="500">
      <v-card>
        <v-card-text class="pt-3">
          <div class="dialog-style">
            <v-icon style="align-self: flex-end" @click="infoDialogMil = false"
              >close</v-icon
            >
          </div>
          <TcMiles :dialog="disableDialog"></TcMiles>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="infoDialogRefuse" width="500">
      <v-card>
        <v-card-text class="pt-3">
          <div class="dialog-style">
            <v-icon
              style="align-self: flex-end"
              @click="infoDialogRefuse = false"
              >close</v-icon
            >
          </div>
          <TcRefuse :dialog="disableDialog"></TcRefuse>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Fin popup del icono de "i" información de cada compensación  -->
    <!-- popup para confirmar la compensación seleccionada -->
    <v-dialog persistent v-model="dialogInf" max-width="529" width="529">
      <v-card>
        <v-card-text class="pt-3">
          <div style="display: flex; flex-direction: column">
            <v-icon style="align-self: flex-end" @click="dialogInf = false"
              >close</v-icon
            >
          </div>
          <div
            class="text-center"
            style="display: flex; flex-direction: column"
          >
            <div
              v-if="
                optionSelected &&
                Object.values(optionSelected).some((option) =>
                  [1, 2, 3].includes(option)
                )
              "
            >
              <h2 class="mb-3 send-dialog-title">
                {{ $t("compensation.confirmText") }}
              </h2>
              <p class="send-dialog-disclaimer mb-2">
                {{ $t("compensation.compensationSelected") }}
              </p>
              <div
                v-for="(passenger, index) in passengerData.filter(
                  (_, i) => optionSelected[i] !== 4
                )"
                :key="index"
                class="send-dialog-resume"
              >
                <h3 class="send-dialog-disclaimer mb-2">
                  {{ passenger.BeneficiaryFirstName }}
                  {{ passenger.BeneficiaryLastName }}
                </h3>
                <div v-if="optionSelected[index] === 1">
                  <h3 class="send-dialog-disclaimer mb-2">
                    {{ $t("compensationSelection.bono") }} -
                    {{ formatAmount(passenger.AEBondAmount) + " €" }}
                  </h3>
                </div>
                <div v-if="optionSelected[index] === 2">
                  <h3 class="send-dialog-disclaimer mb-2">
                    {{ $t("compensationSelection.monetary") }} -
                    {{ formatAmount(passenger.MonetaryMaxAmount) + " €" }}
                  </h3>
                </div>
                <div v-if="optionSelected[index] === 3">
                  <h3 class="send-dialog-disclaimer mb-2">
                    {{ $t("compensationSelection.millas") }} -
                    {{
                      formatMillas(passenger.MilesAmount) +
                      " " +
                      $t("compensation.miles")
                    }}
                  </h3>
                </div>
              </div>
              <div class="send-dialog-disclaimer mt-2">
                <p style="font-size: 0.9em">
                  {{ $t("compensation.disclaimer") }}
                </p>
              </div>
            </div>
            <div v-if="Object.values(optionSelected).includes(4)">
              <div class="send-dialog-disclaimer mt-2">
                <h2 class="mb-3 send-dialog-title">
                  {{ $t("compensationSelection.TcRefuseTitle") }}
                </h2>

                <p style="font-size: 0.9em">
                  {{ $t("compensationSelection.TcRefuseContent") }}
                </p>
              </div>
            </div>
            <v-btn class="btn-bank" @click="sendCompensationSelected">
              {{ $t("compensation.confirmButtonText") }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Fin popup para confirmar la compensacion seleccionada -->
    <!-- Pantalla de error -->
    <ErrorDBC
      v-if="isError"
      class="alert-component"
      :title="isError149 ? $t('error_dbc.title1') : $t('error_dbc.title3')"
      :subtitle="$t('error_dbc.subtitle1')"
    />
    <ErrorDBC
      v-if="isErrorFile"
      class="alert-component"
      :title="isError149 ? $t('error_dbc.title1') : $t('error_dbc.title3')"
      :subtitle="$t('error.error5XXC')"
    />
    <ErrorInfoDBC
      v-if="isInfoDBC"
      class="alert-component"
      :title="$t('error_dbc.title2')"
      :subtitle="isError3 ? $t('error_dbc.subtitle3') : ''"
      :subtitle2="
        isError3 ? $t('error_dbc.subtitle1') : $t('error_dbc.subtitle2')
      "
    />
  </div>
</template>

<script>
import BankDetailsSapErrors from "../dialogs/BankDetailsSapErrors.vue";
import TcAebond from "../compensation/TcAebond.vue";
import TcMonetary from "../compensation/TcMonetary.vue";
import TcMiles from "../compensation/TcMiles.vue";
import TcRefuse from "../newCompensation/TcRefuse.vue";
import Api from "@/api/api.js";
import { useTokenStore } from "@/stores/tokenStore";
import { ValidationObserver } from "vee-validate";
import DynamicForm from "@/components/dynamic/DynamicForm.vue";
import newDataClientDBG from "./newDataClientDBG.vue";
import ErrorDBC from "../newCompensation/ErrorDBC.vue";
import ErrorInfoDBC from "../newCompensation/ErrorInfoDBC.vue";
import { useCompensationStore } from "@/stores/compensationStore";
import { useUiStore } from "@/stores/uiStore";
import { mapStores, mapWritableState } from "pinia";
import SuccessComponent from "../newCompensation//SuccessComponent.vue";
export default {
  name: "NewDBGComponent",
  components: {
    DynamicForm,
    newDataClientDBG,
    ValidationObserver,
    ErrorDBC,
    ErrorInfoDBC,
    BankDetailsSapErrors,
    TcAebond,
    TcMonetary,
    TcMiles,
    TcRefuse,
    SuccessComponent,
  },
  data() {
    return {
      PAGESTATUS_FORM: 0,
      PAGESTATUS_SUCCESS: 1,
      PAGESTATUS_LOADERROR: 2,
      pageStatus: null,
      optionSelected: {},
      formMonetary: [],
      defaultValues: null,
      submittedSuccessfully: false,
      valid: true,
      validationErrors: {},
      duplicateError: false,
      isError: false,
      isError149: false,
      isError6: false,
      isError3: false,
      isInfoDBC: false,
      bankDetailsSapErrorsDialog: {
        open: false,
        errors: [],
      },
      formDataClient: null,
      formDataBank: null,
      formDataMil: null,
      msgRefuse: false,
      infoDialogBon: false,
      infoDialogMon: false,
      infoDialogMil: false,
      infoDialogRefuse: false,
      dialogInf: false,
      uploadResponse: null,
      isErrorFile: false,
      isFormValidFileArr: [],
    };
  },
  created() {
    this.getData();
  },
  computed: {
    isEnglish() {
      return this.$i18n.locale === "en";
    },
    ...mapStores(useTokenStore, useUiStore),

    ...mapWritableState(useCompensationStore, [
      "jsonRes",
      "passengerData",
      "pyId",
      useTokenStore,
    ]),
    isExpiredToken() {
      // return false;
      return this.tokenStore?.isExpiredToken;
    },
    isFormValid() {
      if (!this.passengerData || this.passengerData.length === 0) return false;
      if (this.duplicateError) return false;

      for (let i = 0; i < this.passengerData.length; i++) {
        const selectedOption = this.optionSelected[i];
        if (!selectedOption) return false;

        // Bono
        if (selectedOption === 1) {
          const clientObserver = this.$refs["clientFormObs" + i];
          const clientObs = Array.isArray(clientObserver)
            ? clientObserver[0]
            : clientObserver;
          if (clientObs && !clientObs.flags.valid) return false;
        }

        // Bancario
        if (selectedOption === 2) {
          const bankObserver = this.$refs["bankFormObs" + i];
          const bankObs = Array.isArray(bankObserver)
            ? bankObserver[0]
            : bankObserver;
          if (bankObs && !bankObs.flags.valid) return false;
          // Validación del archivo
          if (
            typeof this.isFormValidFileArr[i] !== "undefined" &&
            !this.isFormValidFileArr[i]
          ) {
            return false;
          }
        }
      }
      return true;
    },

    allCompensationsSelected() {
      return this.passengerData.every((_, index) => this.optionSelected[index]);
    },
    allFormsValid() {
      return this.passengerData.every((_, index) => {
        const clientObserver = this.$refs["clientFormObs" + index];
        const bankObserver = this.$refs["bankFormObs" + index];
        const option = this.optionSelected[index];
        if (option === 1 && clientObserver && clientObserver.validate) {
          return clientObserver.validate().then((result) => result.valid);
        } else if (option === 2 && bankObserver && bankObserver.validate) {
          return bankObserver.validate().then((result) => result.valid);
        } else {
          return true;
        }
      });
    },
  },
  methods: {
    notErrorScreen() {
      this.isError = false;
      this.isError149 = false;
      this.isError6 = false;
      this.isError3 = false;
      this.isInfoDBC = false;
    },
    errorPega(error) {
      if (error?.data?.StatusCode === "1") {
        this.isError = true;
        this.isError149 = true;
      } else if (error?.data?.StatusCode === "2") {
        this.isInfoDBC = true;
        this.isError3 = false;
      } else if (error?.data?.StatusCode === "3") {
        this.isInfoDBC = true;
        this.isError3 = true;
      } else if (error?.data?.StatusCode === "4") {
        this.isError = true;
        this.isError149 = true;
      } else if (error?.data?.StatusCode === "6") {
        this.isError = true;
        this.isError149 = false;
      } else if (error?.data?.StatusCode === "7") {
        this.isInfoDBC = true;
        this.isError3 = false;
      } else if (error?.data?.StatusCode === "9") {
        this.isError = true;
        this.isError149 = true;
      } else if (error?.data?.StatusCode === "10") {
        const sapErrors = this.hasSapErrors(
          error?.data?.ErrorsSAP?.map((error) => error?.Description)
        );
        this.hasSapErrors(sapErrors);
        this.submittedSuccessfully = false;
        this.notErrorScreen();
        this.pageStatus = this.PAGESTATUS_FORM;
      } else {
        return;
      }
    },
    errorForm(e) {
      if (e?.response?.status === 400) {
        this.hasSapErrors(e?.response?.data?.errorDescription?.split(";"));
        this.pageStatus = this.PAGESTATUS_FORM;
      } else if (e?.response?.status === 404) {
        this.setCustomError({
          customError: this.$t("error.error404"),
        });
      } else if (e?.response?.status === 409) {
        this.setCustomError({
          customError: this.$t("error.error409"),
        });
      } else if (e?.response?.status === 410) {
        this.setCustomError({
          customError: this.$t("error.error410C"),
        });
      } else if (e?.response?.status === 423) {
        this.setCustomError({
          customError: this.$t("error.error423C"),
        });
      } else if (e?.response?.status) {
        this.setCustomError({ errorCode: e.response.status });
      }
      this.uiStore.changeSpinner(false);
    },
    setCustomError({ errorCode, customError = "errorsSap.TPY-0100" }) {
      let error = "";
      if (!errorCode && customError) {
        error = customError;
      }
      if (errorCode) {
        let status = errorCode.toString();
        if (status.match(/^5\d{2}$/)) status = "5XXC";
        error = `error.error${status}`;
        if (!this.$te(error)) error = customError;
      }
      this.uiStore.setError({
        message: this.$t(error),
      });
    },
    resetOtherOptions() {
      // Si el primer pasajero selecciona "rechazar" (valor 4)
      if (this.optionSelected[0] === 4) {
        // Resetear las opciones seleccionadas de los demás pasajeros
        this.passengerData.forEach((_, index) => {
          if (index !== 0) {
            this.$set(this.optionSelected, index, null);
          }
        });
      }
    },
    loadBankDetails() {
      try {
        this.currencyCountries = this.jsonRes?.pyItemGroup?.map((i) => i?.Code);
        this.countriesStore.filterWithAvailableCurrency(this.currencyCountries);
      } catch (error) {
        this.errorForm(error);
      }
    },
    onBankFormReady(index, form) {
      this.$set(this.formMonetary, index, form);
    },
    isOptionDisabled(index, optionValue) {
      // Si el primer pasajero ha seleccionado rechazar (valor 4), deshabilitar las opciones para los demás pasajeros
      if (this.optionSelected[0] === 4 && index !== 0) {
        return optionValue !== 4; // Solo permitir la opción de rechazar
      }
      return false; // No deshabilitar ninguna opción por defecto
    },
    async getData() {
      this.uiStore.changeSpinner(true);
      try {
        const response = await Api.getNewCompensation(
          this.tokenStore.caseId,
          this.tokenStore.token
        );
        this.jsonRes = response.data;
        if (this.jsonRes && this.jsonRes.PassengerCase) {
          this.passengerData = this.jsonRes.PassengerCase.map((item) => ({
            ...item.CompensationDetails,
            BeneficiaryName:
              item.CompensationDetails.BeneficiaryName || item.BeneficiaryName,
            AEBondAmount: item.AEBondAmount,
            MilesAmount: item.MilesAmount,
            MonetaryMaxAmount: item.MonetaryMaxAmount,
          }));
          this.pageStatus = this.PAGESTATUS_FORM;
        } else if (response?.data?.StatusCode !== "0") {
          this.errorPega(response);
        }
        this.uiStore.changeSpinner(false);
      } catch (e) {
        this.errorPega(e);
      }
    },
    shouldDisplayDynamicForm(index) {
      // Mostrar solo un DynamicForm si hay un pasajero o más con opción 2
      const firstIndex = this.passengerData.findIndex(
        (_, idx) => this.optionSelected[idx] === 2
      );
      return firstIndex === index;
    },
    disableDialog() {
      this.infoDialogBon = false;
      this.infoDialogMon = false;
      this.infoDialogMil = false;
      this.infoDialogRefuse = false;
    },
    infoBon() {
      this.infoDialogBon = true;
    },
    infoMon() {
      this.infoDialogMon = true;
    },
    infoMil() {
      this.infoDialogMil = true;
    },
    infoRefuse() {
      this.infoDialogRefuse = true;
    },
    openDialog() {
      this.dialogInf = true;
    },

    formatAmount(amount) {
      const amountTrunc = Math.trunc(amount);
      const hasDecimal = amount !== amountTrunc;
      if (hasDecimal) {
        const amountRound = Math.round(amount * 100) / 100;
        return amountRound.toLocaleString();
      } else {
        return amountTrunc.toLocaleString();
      }
    },
    formatMillas(amount) {
      const amountTrunc = Math.trunc(amount);
      return amountTrunc.toLocaleString();
    },
    allCompensationsRejected() {
      return this.passengerData.some(
        (_, index) => this.optionSelected[index] === 4
      );
    },
    handleValidation(index, { lastName, secondLastName }) {
      this.$set(this.validationErrors, index, {
        lastName: !lastName.isValid,
        secondLastName: !secondLastName.isValid,
      });

      this.passengerData[index].BeneficiaryLastName = lastName;
      this.passengerData[index].BeneficiarySecondLastName = secondLastName;
      this.checkForDuplicates();
    },
    handleDocChange(index, { docNumber, docType }) {
      // Actualizar los datos del pasajero
      this.passengerData[index].BeneficiaryDocNumber = docNumber;
      this.passengerData[index].BeneficiaryDocType = docType;

      // Verificar duplicados globalmente
      this.checkForDuplicates();
    },
    checkForDuplicates() {
      // Filtrar pasajeros que han seleccionado la opción de bono (opción 1)
      const passengersWithBono = this.passengerData.filter(
        (_, index) => this.optionSelected[index] === 1
      );

      // Solo ejecutar la comprobación si hay 2 o más pasajeros con bono
      if (passengersWithBono.length < 2) {
        this.duplicateError = false;
        return;
      }

      const seen = new Set();

      this.duplicateError = passengersWithBono.some((passenger) => {
        if (!passenger.BeneficiaryDocNumber?.trim()) {
          // Ignorar pasajeros con número de documento vacío
          return false;
        }

        // Normalizar el número de documento
        const normalizedDocNumber =
          passenger.BeneficiaryDocNumber.trim().toLowerCase();
        const key = `${passenger.BeneficiaryDocType}-${normalizedDocNumber}`;

        if (seen.has(key)) {
          return true; // Duplicado encontrado
        }
        seen.add(key);
        return false;
      });
    },
    bankDetailsSapErrorsDialogToggle() {
      this.bankDetailsSapErrorsDialog.open =
        !this.bankDetailsSapErrorsDialog.open;
    },
    hasSapErrors(sapErrors) {
      if (!sapErrors) return;
      this.bankDetailsSapErrorsDialog = {
        open: true,
        errors: sapErrors,
      };
    },
    /**
     * Este método ejecuta un componente de submit según la compensation seleccionada
     */
    async sendCompensationSelected() {
      try {
        const allCompensationData = []; // Array para recopilar los datos de todos los pasajeros
        let hasMonetaryOption = false; // Bandera para verificar si algún pasajero tiene selectedOption === 2
        this.dialogInf = false;
        for (let index = 0; index < this.passengerData.length; index++) {
          const selectedOption = this.optionSelected[index];

          if (selectedOption === 1) {
            this.mapClientForm(index);
            allCompensationData.push(this.jsonRes);
          } else if (selectedOption === 2) {
            hasMonetaryOption = true; // Marcar que hay al menos un pasajero con opción 2
            await this.fileMapped(index);
            this.mapBankForm(index);
            allCompensationData.push(this.jsonRes);
          } else if (selectedOption === 3) {
            this.mapMilesForm(index);
            allCompensationData.push(this.jsonRes);
          } else if (selectedOption === 4) {
            this.mapRefuseForm(index);
            allCompensationData.push(this.jsonRes);
          }
        }
        // Realizar una única petición con todos los datos recopilados
        this.uiStore.changeSpinner(true);
        if (hasMonetaryOption) {
          await this.fileUpdated();
        } else {
          const response = await Api.sendCompensationData(this.jsonRes);
          this.commonMethod(response);
        }
      } catch (e) {
        this.errorForm(e);
      }
    },
    async fileMapped(index) {
      const bankForm = { ...this.formMonetary[index] };

      const uploadedFile = bankForm.uploadedFile;
      if (uploadedFile && uploadedFile.name) {
        try {
          this.uploadResponse = await Api.uploadFileWithId(
            uploadedFile,
            this.jsonRes.pyID
          );
        } catch (error) {
          this.setCustomError({
            customError: this.$t("error.error5XXC"),
          });
        }
      }
    },
    async fileUpdated() {
      try {
        if (this.uploadResponse?.status === 200) {
          const response = await Api.sendCompensationData(this.jsonRes);
          this.commonMethod(response);
        } else {
          this.isErrorFile = true;
          this.uiStore.changeSpinner(false);
          this.setCustomError({
            customError: this.$t("error.error5XXC"),
          });
        }
      } catch (e) {
        this.errorForm(e);
      }
    },

    commonMethod(e) {
      this.jsonPost = e.data.CompensationDetails;

      if (e.data.StatusCode === "0") {
        this.submittedSuccessfully = true;
        this.pageStatus = this.PAGESTATUS_SUCCESS;
      } else {
        this.errorPega(e);
      }
      this.uiStore.changeSpinner(false);
    },
    /** Mapeo Json del post de bono y monetaria*/
    mapClientForm(index) {
      const passenger = this.passengerData[index]; // Obtener los datos del pasajero actual
      const dataClient = this.$refs["dataClient" + index]?.dataClient; // Referencia dinámica al formulario del pasajero

      // Actualizar directamente el objeto PassengerCase correspondiente
      this.jsonRes.PassengerCase[index].CompensationDetails = {
        ...passenger.CompensationDetails, // Mantener los datos existentes
        AEBondAccepted: "true", // Marcar que el bono ha sido aceptado
        BeneficiaryDocNumber:
          dataClient?.documentNumber || passenger.BeneficiaryDocNumber,
        BeneficiaryDocType:
          dataClient?.documentTypes || passenger.BeneficiaryDocType,
        BeneficiaryFirstName:
          dataClient?.firstName || passenger.BeneficiaryFirstName,
        BeneficiaryLastName:
          dataClient?.lastName || passenger.BeneficiaryLastName,
        BeneficiarySecondLastName:
          dataClient?.secondLastName || passenger.BeneficiarySecondLastName,
      };

      // Eliminar propiedades innecesarias
      delete this.jsonRes.PassengerCase[index].CompensationDetails
        .AEBondCompensationAcceptedText;
      delete this.jsonRes.PassengerCase[index].CompensationDetails
        .MonetaryCompensationAcceptedText;
      this.jsonRes.pyItemGroup = "";
    },

    async mapBankForm(index) {
      const bankForm = { ...this.formMonetary[index] };
      const comp = this.jsonRes.PassengerCase[index].CompensationDetails || {};

      comp.MonetaryAccepted = "true";
      comp.CountryCode = bankForm.CountryCode || "";
      comp.AccountHolderName = bankForm.AccountHolderName || "";
      comp.AccountHolderDocType = bankForm.AccountHolderDocType || "";
      comp.AccountHolderDocNumber = bankForm.AccountHolderDocNumber || "";
      comp.AccountNumber = bankForm.AccountNumber || "";
      comp.BankName = bankForm.BankName || "";
      comp.BankCode = bankForm.BankCode || "";
      comp.SWIFT = bankForm.SWIFT || "";
      comp.SWIFT2 = bankForm.SWIFT2 || "";
      comp.IBAN = bankForm.IBAN || "";
      comp.RefBank = bankForm.RefBank || "";
      comp.ControlDigit = bankForm.ControlDigit || "";
      comp.AccountTypeBankDetails = bankForm.AccountTypeBankDetails || "";
      comp.AddressLine2 = bankForm.AddressLine2 || "";
      comp.AccountCurrency = bankForm.AccountCurrency || "";
      let formattedFileName = "";
      if (bankForm.uploadedFile && bankForm.uploadedFile.name) {
        formattedFileName = bankForm.uploadedFile.name
          .normalize("NFD") // Descompone caracteres con tildes
          .replace(/[\u0300-\u036f]/g, "") // Elimina marcas diacríticas
          .replace(/ñ/g, "n") // Reemplaza ñ con n
          .replace(/Ñ/g, "N")
          .replace(/-/g, "_") // Reemplaza guiones con guiones bajos
          .replace(/[^a-zA-Z0-9._-]/g, "_"); // Reemplaza caracteres especiales con _
      }
      comp.uploadedFile = formattedFileName;
      this.jsonRes.PassengerCase[index].CompensationDetails = comp;
      this.jsonRes.pyItemGroup = "";
      this.formDataBank = this.jsonRes.PassengerCase[index].CompensationDetails;
    },

    mapMilesForm(index) {
      const passenger = this.passengerData[index];
      // Actualizar directamente el objeto PassengerCase correspondiente
      this.jsonRes.PassengerCase[index].CompensationDetails = {
        ...passenger.CompensationDetails, // Mantener los datos existentes
        MilesAccepted: "true",
        BeneficiaryDocNumber: passenger.BeneficiaryDocNumber,
        BeneficiaryDocType: passenger.BeneficiaryDocType,
        BeneficiaryFirstName: passenger.BeneficiaryFirstName,
        BeneficiaryLastName: passenger.BeneficiaryLastName,
        BeneficiarySecondLastName: passenger.BeneficiarySecondLastName,
      };

      // Eliminar propiedades innecesarias
      this.jsonRes.PassengerCase[index].CompensationDetails
        .AEBondCompensationAcceptedText;
      this.jsonRes.PassengerCase[index].CompensationDetails
        .MonetaryCompensationAcceptedText;
      this.jsonRes.pyItemGroup = "";
    },

    mapRefuseForm(index) {
      const passenger = this.passengerData[index];
      this.formDataRefuse = { ...this.jsonRes };
      this.formDataRefuse.CompensationDetails = {
        ...passenger,
      };
      // Eliminar propiedades innecesarias

      delete this.formDataRefuse.CompensationDetails
        .AEBondCompensationAcceptedText;
      delete this.formDataRefuse.CompensationDetails
        .MonetaryCompensationAcceptedText;
      this.jsonRes.pyItemGroup = "";
    },
    /** Fin de los métodos de post */
    onFormValidity(isValid, index) {
      this.$set(this.isFormValidFileArr, index, isValid);
    },
  },
  watch: {
    optionSelected: {
      handler() {
        this.checkForDuplicates();
        this.resetOtherOptions();
      },
      deep: true,
    },
    validationErrors: {
      handler() {
        // Forzar la reactividad de isFormValid
        this.isFormValid;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.new-dbg-component {
  /* Your component styles here */
}

.alert-success {
  width: fit-content;
  box-shadow: 0px 5px 10px rgba(204, 204, 204, 0.3);
  padding: 50px;
  border-radius: 20px;
  margin: 10em auto;
  @media (max-width: 768px) {
    padding: 30px;
  }
  @media (max-width: 480px) {
    padding: 20px;
  }
}

.text-success {
  font-family: Lato;
  font-size: 18px;
  line-height: 26px;
  color: #0d0d0d;
  @media (max-width: 600px) {
    margin-left: 10px;
    margin-right: 10px;
  }
}

.section-heading {
  color: #0f2367;
  font-family: AERadar;
  font-size: 16px;
  padding-bottom: 15px;
}

.data-form {
  background-color: #f6f6f6;
  padding: 28px;
  border-radius: 10px;
  @media (max-width: 992px) {
    padding: 12px;
  }
}

.compensation-style {
  cursor: pointer;
  display: flex;
  font-family: Lato, sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #0f2367;
  line-height: 24px;
  align-items: center;
}

.v-col {
  flex-grow: 1; /* Permite que las columnas visibles ocupen el espacio disponible */
  text-align: center;
}

.icon-style {
  width: 12px;
  height: 12px;
  margin-top: 0;
  margin-left: 1px;
}

.amounts-style {
  cursor: pointer;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
}

.icon-user,
.icon-user2 {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

.icon-user2 {
  margin-left: 10px;
}

.user-name {
  font-family: Aeradar-Bold, sans-serif;
  text-align: left;
  color: #2d69e1;
  font-size: 16px;
}

@media (max-width: 600px) {
  ::v-deep .custom-radio .v-input--selection-controls__input {
    transform: scale(0.8);
  }
  ::v-deep .custom-col {
    max-width: 100% !important;
  }
  ::v-deep .v-container {
    margin: 0 !important;
    padding: 0 !important;
    max-width: 100% !important;
  }
  ::v-deep .v-row {
    margin: 0 !important;
    padding: 0 !important;
    max-width: 100% !important;
  }
  ::v-deep .v-input--selection-controls__ripple {
    max-width: 100% !important;
  }
}
.bono-title {
  font-family: AERadar;
  font-size: 20px;
  margin: 10px 0;
  color: #0f2367;
  @media (max-width: 768px) {
    font-size: 18px;
  }
  @media (max-width: 480px) {
    font-size: 16px;
  }
}

.dialog-style {
  display: flex;
  overflow-x: hidden;
  overflow-y: hidden;
  flex-direction: column;
}

.info-style {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 5em 2em;

  @media (max-width: 1200px) {
    padding: 5em 2em;
  }

  @media (max-width: 768px) {
    padding: 3em 1.5em;
  }

  @media (max-width: 480px) {
    padding: 2em 1em;
  }
}
.empty-cell {
  height: 40px; /* Altura consistente con las celdas con contenido */
  background-color: transparent; /* Fondo transparente */
}

.info-title {
  color: #2d69e1;
  font-size: 30px;
  margin-bottom: 20px;
  font-family: Lato, -apple-system, blinkmacsystemfont, Segoe UI, Roboto,
    Helvetica Neue, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    Segoe UI Symbol, icomoon;

  @media (max-width: 768px) {
    font-size: 24px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
  }
}
info-Des {
  font-size: 18px;
  font-family: Lato, -apple-system, blinkmacsystemfont, Segoe UI, Roboto,
    Helvetica Neue, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    Segoe UI Symbol, icomoon;
  width: 100%;
  max-width: 100%;
  text-align: center;
  margin: 0 auto;
  padding: 0 1em;

  @media (max-width: 1200px) {
    font-size: 16px;
    padding: 0 1em;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 0 0.5em;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    padding: 0 0.25em;
  }
}
.alert-error {
  width: 25px;
}
.text-error {
  position: absolute;
  right: 0;
  color: red;
  bottom: 0px;
  font-size: 14px;
  margin-right: 20px;
}

.alert-component {
  margin: 12em !important;
  display: flex;
  justify-content: center;
}
</style>
